import React, { useEffect, useState } from "react";
import _ from "lodash";
import "./ProjectDetailsPage.css";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPortfolios } from "../features/dataSlice";
import { css } from "@emotion/core";
import RingLoader from "react-spinners/RingLoader";
import { db } from "../config/firebase";

const override = css`
  display: block;
  margin: auto;
  margin-left: -10%;
  border-color: red;
`;

const ProjectDetailsPage = () => {
  const portfolios = useSelector(getPortfolios);

  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = "Ashwin's Portfolio - Details";
    if (id) {
      let index = portfolios.map((e) => e.id).indexOf(id);
      let _data = _.cloneDeep(portfolios[index]);
      setData(_data);
    }

    if (data === null && id) {
      db.collection("ashwin-projects")
        .doc(id)
        .onSnapshot((snap) => {
          setData(snap.data());
        });
    }
    return () => {
      //
    };
  }, []);

  return (
    <div className="projectDetailsPage">
      <div className="header-proj">
        <ArrowBackIcon onClick={() => history.goBack()} />
      </div>
      {data ? (
        <div className="body-proj">
          <h2>
            <span className="proj-title">{data.name}</span>
          </h2>
          <div className="proj-details">
            <h4>Details:</h4>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This website
              belongs to the category of {data.category}. This website is built
              in {data.language} using {data.frontEnd} as front end technology,{" "}
              {data.backEnd} as back end technology and {data.db} as database.
              <br />
              <br />
              To visit site{" "}
              <a target="_blank" href={data.url}>
                click here
              </a>
            </p>
          </div>
          <div className="proj-snaps">
            <h4>Snaps:</h4>
            <div className="proj-images">
              <img
                loading="lazy"
                src={data.imageURL1}
                alt=""
                className="proj-image"
              />
              <img
                loading="lazy"
                src={data.imageURL2}
                alt=""
                className="proj-image"
              />
              <img
                loading="lazy"
                src={data.imageURL3}
                alt=""
                className="proj-image"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="body-proj">
          <div className="sweet-loading">
            <RingLoader
              color={"#17D0D3"}
              loading={!data}
              css={override}
              size={150}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetailsPage;
